// extracted by mini-css-extract-plugin
module.exports = {"statusSelect":"ContactSection_statusSelect__yMlyq","section":"ContactSection_section__3hFKs"};